import React from 'react';
import {FAQSection} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import styled from 'styled-components';
import {QuestionsSection} from './questions-section';

interface FaqSectionProps {
  translations: FAQSection;
}

export function FaqSection(props: FaqSectionProps): JSX.Element {
  const {translations} = props;

  return (
    <FaqLayout>
      <QuestionsSection translations={translations} />
    </FaqLayout>
  );
}

const FaqLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-inline-start: ${(props) =>
    props.theme.brand.spacing.faqLayout?.inlineStart ?? '0'};
  padding-inline-end: ${(props) =>
    props.theme.brand.spacing.faqLayout?.inlineEnd ?? '0'};
`;
